import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/signatures',
    name: 'signature',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/signature/index.vue')
  }
]
